import React from 'react'
import { Card, CardBody } from 'reactstrap'

// const ComplianceCard = this.props => {
class ComplianceCard extends React.Component {
  render () {
    let classes = ''
    if (this.props.hoverColor) {
      classes += ' card-hover '
    }
    if (this.props.isActive) {
      classes = 'compliance-card-active '
    }

    return (

      <Card style={this.props.clickable ? { width: 350, cursor: 'pointer' } : { width: 350 }}>
        <CardBody className={classes + this.props.bgColor} onClick={() => {
          if (this.props.clickable) {
            // console.log(this.props.category)
            this.props.setUpdate(this.props.category, this.props.selectedCatName.name)
            this.props.changeCategory(this.props.id)
          }
          // return this.props.clickable ?  : null
        }}>
          {
            this.props.title
              ? <h3>{this.props.title}</h3>
              : this.props.category
                ? <h5 style={{ height: 30 }}>{this.props.category}</h5>
                : null
          }
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center'
          }}>
            <div style={{
              fontSize: 50,
              color: this.props.percentage_color,
              paddingRight: 20
            }}>
              {this.props.percentage}%
            </div>
            <div style={{
              fontSize: 16,
              fontWeight: 200,
              paddingLeft: 50,
              color: 'grey',
              borderLeft: '2px solid #D9DBDC'
            }}>
              {`${this.props.numberCompliance} of ${this.props.totalControls} passed`}
            </div>
          </div>
        </CardBody>
      </Card>
    )
  }
}

export default ComplianceCard



// WEBPACK FOOTER //
// ./src/components/vendor_assessments/conponents/compliance-card.js